// extracted by mini-css-extract-plugin
export default {"icon-button":"IconButton_icon-button__ZgWZs","borderless":"IconButton_borderless__6pI+s","small":"IconButton_small__-E9pH","large":"IconButton_large__cKDjW"};